import { Badge, Flex } from 'antd';
import { useMemo } from 'react';

import {
  usePendingOpenReportMessages,
  usePendingOpenTickets,
  useTeacherPendingMessages
} from '@/store';
import { formatBadgeCount } from '@/utils';

export const PendingSupportsBadge = () => {
  const { pendingTickets = 0, isLoading: isLoadingTickets } = usePendingOpenTickets();
  const { pendingMessages = 0, isLoading: isLoadingTutoringGroups } = useTeacherPendingMessages();
  const { pendingReports = 0, isLoading: isLoadingProblemReports } = usePendingOpenReportMessages();

  const totalPendingMessages = useMemo(() => {
    return pendingTickets + pendingMessages + pendingReports;
  }, [pendingTickets, pendingMessages, pendingReports]);

  if (isLoadingTickets || isLoadingTutoringGroups || isLoadingProblemReports) return null;

  const displayCount = formatBadgeCount(totalPendingMessages);
  if (!displayCount) return null;

  return (
    <Flex align="center" justify="center">
      <Badge count={displayCount} />
    </Flex>
  );
};
